import $ from 'jquery';

const IMAGES = [0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7];

const BGs = [
	'#fdc689',
	'#ffdbc2',
	'#fcbf5a',
	'#ed1c24',
	'#fdc689',
	'#ffff00',
	'#ff3000',
	'#ff5e2f',
	'#ff5e2f',
	'#ffdbc2',
	'#fcbf5a',
	'#ffff00',
	'#f69679',
	'#ed1c24',
	'#ff3000',
	'#f69679'
];

class Game {
	constructor() {
		this.$game = $('.game');
		this.$startBtn = $('.game__btn');
		this.$squares = $('.square');
		this.$popup = $('.popup__content');
		this.$sharing = $('.popup__sharing');
		this.ready = false;
		this.store = [];
		this.successStore = [];
		this.timeStart = '';
		this.timeEnd = '';
		this.delays = {
			shake: 500,
			flipping: 1000,
			showAll: 2000
		};
		this.url = '/data/get_time.php';
	}

	init() {
		this.bindEvents();
		this.setBGsColors();
		this.setImages();
	}

	fetchDataByUrl = async (url, params = {}) => {
		try {
			const response = await window.fetch(url, params);
			if (response.ok) {
				const json = await response.json();
				return json;
			}
		}catch (e) {
			console.error('Error in fetch', e);
		}
	}

	getResults() {
		const gameTime = this.timeEnd - this.timeStart;
		const params = {
			method: 'POST',
			mode: 'cors',
			cache: 'no-cache',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'text/php'
			},
			redirect: 'follow',
			referrer: 'no-referrer',
			body: JSON.stringify({ time: gameTime })
		};
		this.fetchDataByUrl(this.url, params)
			.then(resp => {
				if (resp) {
					this.$sharing.find('.sharing__list').attr({
						'data-image': resp['data-image'],
						'data-title': resp['data-title'],
						'data-url': resp['data-url']
					});
					const $title = $('<h4></h4>').attr({ class: 'popup__title' }).text(resp.header);
					const $caption = $('<p></p>').attr({ class: 'popup__caption' }).text(resp.desc);
					const $text = $('<p></p>').attr({ class: 'popup__text' }).html(resp.text);
					$title.appendTo(this.$popup);
					$caption.appendTo(this.$popup);
					$text.appendTo(this.$popup);
				}
			});
	}

	bindEvents() {
		this.$startBtn.on('click', this.handleStartBtnClick);
		this.$squares.on('click', this.handleSquareClick);
	}

	handleStartBtnClick = () => {
		this.$game.addClass('active');
		this.showAllSquares(this.delays.showAll);
		this.timeStart = new Date().getTime();
	}

	handleSquareClick = e => {
		if (this.ready) {
			const squareId = $(e.target).parent().attr('data-square-id');
			const imageId = $(e.target).parent().attr('data-image-id');
			const card = {
				squareId,
				imageId
			};
			if (this.store.length <= 1 && !$(this.$squares[squareId]).hasClass('flipping')) {
				this.store.push(card);
				$(this.$squares[squareId]).addClass('flipping');
			}
			this.checkStore();
		}
	}

	checkStore() {
		if (this.store.length === 2) {
			if (this.store[0].imageId === this.store[1].imageId) {
				const arr = this.successStore.concat(this.store);
				this.successStore = arr;
				this.store = [];
			} else {
				this.ready = false;
				this.store.forEach(item => {
					setTimeout(() => {
						$(this.$squares[item.squareId]).addClass('shake');
					}, this.delays.shake);
					setTimeout(() => {
						$(this.$squares[item.squareId]).removeClass('flipping shake');
						this.ready = true;
					}, this.delays.flipping);
				});
				this.store = [];
			}
		}

		if (this.successStore.length === this.$squares.length) {
			this.endGame();
		}
	}

	endGame() {
		this.$game.addClass('endgame');
		this.timeEnd = new Date().getTime();
		this.getResults();
	}

	showAllSquares(delay) {
		this.$squares.each(id => {
			$(this.$squares[id]).addClass('flipping');
			setTimeout(() => {
				$(this.$squares[id]).removeClass('flipping');
			}, delay);
		});
		setTimeout(() => {
			this.ready = true;
		}, delay);
	}

	randomInteger = (min, max) => {
		let random = min + Math.random() * (max + 1 - min);
		return Math.floor(random);
	}

	getImage(index) {
		return `../../img/game-img-${index}.jpg`;
	}

	setBGsColors() {
		this.$squares.each(id => {
			$(this.$squares[id]).attr('data-square-id', id);
			$(this.$squares[id]).children('.square__front').css({ backgroundColor: BGs[id] });
		});
	}

	setImages() {
		const arr = IMAGES;
		this.$squares.each(id => {
			const index = this.randomInteger(0, arr.length - 1);
			$(this.$squares[id]).attr('data-image-id', arr[index]);
			$(this.$squares[id])
				.children('.square__back')
				.css({ backgroundImage: `url(${this.getImage(arr[index])})` });
			arr.splice(index, 1);
		});
	}
}

export default Game;



// WEBPACK FOOTER //
// ./app/scripts/game.js